import type { Quality } from "@elektr/shared";

// Kalitlar literal: i18n testi manba kodidan topadi
export const QUALITY_KEYS: Record<Quality, string> = {
  economy: "quality.economy",
  standard: "quality.standard",
  premium: "quality.premium",
};
export const QUALITY_TONE: Record<Quality, "neutral" | "info" | "warning"> = {
  economy: "neutral",
  standard: "info",
  premium: "warning",
};
export const LEAD_STATUS_KEYS = {
  new: "lead.status_new",
  contacted: "lead.status_contacted",
  sold: "lead.status_sold",
  rejected: "lead.status_rejected",
} as const;
export const LEAD_STATUS_TONE = {
  new: "warning",
  contacted: "info",
  sold: "success",
  rejected: "danger",
} as const;

/** Mahsulot ro'yxati so'rovi uchun URL parametrlaridan filtr obyekti. */
export function catalogQuery(sp: URLSearchParams, pageSize: number, me: boolean) {
  const num = (k: string) => (sp.get(k) && /^\d+$/.test(sp.get(k)!) ? sp.get(k)! : undefined);
  return {
    page: Number(sp.get("page") ?? 1) || 1,
    page_size: pageSize,
    q: sp.get("q") || undefined,
    category: sp.get("category") || undefined,
    brand: sp.get("brand") || undefined,
    quality: sp.get("quality") || undefined,
    price_min: num("price_min"),
    price_max: num("price_max"),
    in_stock: sp.get("in_stock") === "true" ? "true" : undefined,
    ordering: sp.get("ordering") || undefined,
    electrician: me && sp.get("mine") === "1" ? "me" : undefined,
  };
}
